import script from "./WhatsAppPromoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppPromoCard.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppPromoCard.vue?vue&type=style&index=0&id=fca7d78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fca7d78a"]])

export default __exports__